<template>
  <page>
    <div>
                <!-- <message :messages="messages"></message> -->
              <v-expansion-panels v-model="panel1" multiple>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
                    </v-expansion-panel-header>
                <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                      <v-flex xs6 md6>
                        <cal-picker
                          v-model="form.tranDate"
                          :label="labels.tranDate"
                          :data-vv-as="labels.tranDate"
                          data-vv-name="form.tranDate"
                          :error-messages="errors.collect('form.tranDate')"
                          v-validate="'required'"
                          @change="doValTranDate()"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6 md6>
                        <cal-picker
                          v-model="form.cutOffDate"
                          :label="labels.cutOffDate"
                          :data-vv-as="labels.cutOffDate"
                          data-vv-name="form.cutOffDate"
                          :error-messages="errors.collect('form.cutOffDate')"
                          v-validate="doValidateCutOffDate"
                        ></cal-picker>
                      </v-flex>
                      <v-flex xs6 md6>
                          <v-text-field
                            ref="maxDebit"
                            v-model="form.maxDebit"
                            :label="labels.maxDebit"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs6 md6>
                          <v-text-field
                            ref="maxCredit"
                            v-model="form.maxCredit"
                            :label="labels.maxCredit"
                            v-num-mask="{ negative: true, intScale: 18, decScale: 2 }"
                          ></v-text-field>
                      </v-flex>
                      </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-spacer class="mt-3"></v-spacer>
                <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.acctNoFrom"
                              :label="labels.acctNoFrom"
                              :error-messages="errors.collect('form.acctNoFrom')"
                              data-vv-name="form.acctNoFrom"
                              :data-vv-as="labels.acctNoFrom"
                              v-validate="acctNoFromValidate()"
                              readonly
                              clearable
                              ><v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('acctNoFrom')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.acctNoTo"
                              :label="labels.acctNoTo"
                              :error-messages="errors.collect('form.acctNoTo')"
                              data-vv-name="form.acctNoTo"
                              :data-vv-as="labels.acctNoTo"
                              v-validate="acctNoToValidate()"
                              readonly
                              clearable
                              ><v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="doHelpList('acctNoTo')">mdi-magnify</v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="form.branch"
                            :label="labels.branch"
                            :error-messages="errors.collect('form.branch')"
                            data-vv-name="form.branch"
                            :data-vv-as="labels.branch"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showBranchHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="form.curr"
                            :label="labels.curr"
                            :error-messages="errors.collect('form.curr')"
                            data-vv-name="form.curr"
                            :data-vv-as="labels.curr"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="form.interType"
                            :label="labels.interType"
                            :error-messages="errors.collect('form.interType')"
                            :data-vv-as="labels.interType"
                            data-vv-name="form.interType"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showInterTypeHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-text-field
                            readonly
                            v-model="form.clientType"
                            :label="labels.clientType"
                            :error-messages="errors.collect('clientType')"
                            :data-vv-as="labels.clientType"
                            data-vv-name="clientType"
                            append-icon="mdi-magnify"
                            @click:append="multiClientTypeList = true"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-autocomplete :items="transactionList" v-model="form.transactions" :label="labels.transactions" item-text="label" item-value="value"
                          data-vv-name="transactions" :data-vv-as="labels.transactions" :error-messages="errors.collect('transactions')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 v-if = "form.transactions == 'All'">
                          <v-autocomplete :items="transactionType" v-model="form.transactionType" :label="labels.transactionType" item-text="label" item-value="value"
                          data-vv-name="transactionType" :data-vv-as="labels.transactionType" :error-messages="errors.collect('transactionType')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 v-if = "form.transactions == 'AT'">
                          <v-autocomplete :items="acctTransactionList" v-model="form.transactionType" :label="labels.transactionType" item-text="label" item-value="value"
                          data-vv-name="transactionType" :data-vv-as="labels.transactionType" :error-messages="errors.collect('transactionType')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 v-if = "form.transactions == 'UT'">
                          <v-autocomplete :items="uwTransactionList" v-model="form.transactionType" :label="labels.transactionType" item-text="label" item-value="value"
                          data-vv-name="transactionType" :data-vv-as="labels.transactionType" :error-messages="errors.collect('transactionType')"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 v-if = "form.transactions == 'CT'">
                          <v-autocomplete :items="clmTransactionList" v-model="form.transactionType" :label="labels.transactionType" item-text="label" item-value="value"
                          data-vv-name="transactionType" :data-vv-as="labels.transactionType" :error-messages="errors.collect('transactionType')"></v-autocomplete>
                        </v-flex>

                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-spacer class="mt-3"></v-spacer>
                <v-btn class="mr-2" :loading="submitting" color="error" dark @click.prevent="doCancel"
                  >{{ labels.cancel }}<v-icon dark right>mdi-cancel</v-icon></v-btn
                >
                <v-btn :loading="submitting" color="primary" @click="doSubmit">{{ labels.schedule }}<v-icon dark right>mdi-clock</v-icon></v-btn>
    </div>

    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssign('branch', $event)"></multi-branch-help-list>
    </v-dialog>

    <v-dialog v-model="showCurrencyHelpList" width="900px" persistent>
      <multi-currency-help-list
        :curr="form.curr"
        :param="'postExcDiff'"
        @close="showCurrencyHelpList = false"
        @doAssign="doAssign('currency', $event)"
      ></multi-currency-help-list>
    </v-dialog>

    <v-dialog v-model="showInterHelpList" width="900px" persistent>
      <intermediary-help-list
        :interGrps="'10,11,20,25'"
        @close="showInterHelpList = false"
        @assign-intermediary="doAssign('inter', $event)"
      ></intermediary-help-list>
    </v-dialog>

    <v-dialog v-model="multiClientTypeList" width="900px" persistent>
      <multi-client-type-help-list
        :clientType="form.clientType"
        @close="multiClientTypeList = false"
        @doAssign="doAssignClientType($event)"
      ></multi-client-type-help-list>
    </v-dialog>

    <v-dialog v-model="showInterTypeHelpList" width="900px" persistent>
      <multi-intermediary-type-help-list
        :interType="form.interType"
        @close="showInterTypeHelpList = false"
        @doAssign="doAssign('interType', $event)"
      ></multi-intermediary-type-help-list>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <span class="info-dialog-msg-header">Oops something went wrong...</span>
              <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiCurrencyHelpList from '@/components/core/common/dialog/MultiCurrencyHelpList'
import MultiClientTypeHelpList from '@/components/core/common/dialog/MultiClientTypeHelpList.vue'
import MultiIntermediaryTypeHelpList from '@/components/core/common/dialog/MultiIntermediaryTypeHelpList.vue'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        tranDate: 'Set Write-off Transaction Date',
        cutOffDate: 'No Write-off for Transactions with Date AFTER',
        maxDebit: 'Maximum Debit(+) Amount',
        maxCredit: 'Maximum Credit(-) Amount',
        acctNoFrom: 'Account No. From',
        acctNoTo: 'Account No. To',
        branch: 'Branch',
        curr: 'Currency',
        clientType: 'Client Type',
        transactions: 'Transactions',
        transactionType: 'Transaction Type',
        interType: 'Intermediary Type',
        cancel: 'Cancel',
        schedule: 'Schedule',
        submit: 'Submit'
      },
      form: {
        tranDate: new Date(),
        cutOffDate: new Date(),
        maxDebit: 0.00,
        maxCredit: 0.00,
        acctNoFrom: '',
        acctNoTo: '',
        branch: 'All',
        curr: 'All',
        clientType: 'All',
        transactionType: 'All',
        transactions: 'All',
        interType: 'All'
      },
      loading: false,
      submitting: false,
      showBranchHelpList: false,
      showCurrencyHelpList: false,
      showInterHelpList: false,
      showInterTypeHelpList: false,
      multiClientTypeList: false,
      scheduleJobModal: false,
      showErrorDialog: false,
      transactionList: [
        {
          label: 'All Transactions',
          value: 'All'
        },
        {
          label: 'Account Transactions',
          value: 'AT'
        },
        {
          label: 'Underwriting Transactions',
          value: 'UT'
        },
        {
          label: 'Claim Transactions',
          value: 'CT'
        }
      ],
      acctTransactionList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'A - Debit Adjustment',
          value: 'A'
        },
        {
          label: 'B - Credit Adjustment',
          value: 'B'
        },
        {
          label: 'Y - Receipt',
          value: 'Y'
        },
        {
          label: 'Z - Payment',
          value: 'Z'
        }
      ],
      uwTransactionList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'M - Direct Business Debit Note',
          value: 'M'
        },
        {
          label: 'N - Coinsurance Outward Debit Note',
          value: 'N'
        },
        {
          label: 'O - Reinsurance Inward Debit Note',
          value: 'O'
        },
        {
          label: 'P - Reinsurance Outward Debit Note',
          value: 'P'
        },
        {
          label: 'Q - Miscellaneous Debit Note',
          value: 'Q'
        },
        {
          label: 'R - Direct Business Credit Note',
          value: 'R'
        },
        {
          label: 'S - Coinsurance Inward Credit Note',
          value: 'S'
        },
        {
          label: 'T - Reinsurance Inward Credit Note',
          value: 'T'
        },
        {
          label: 'U - Reinsurance Outward Credit Note',
          value: 'U'
        },
        {
          label: 'V - Miscellaneous Credit Note',
          value: 'V'
        }
      ],
      clmTransactionList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'W - Claims Debit Note',
          value: 'W'
        },
        {
          label: 'X - Claims Credit Note',
          value: 'X'
        }
      ],
      transactionType: [
        {
          label: 'All',
          value: 'All'
        }
      ],
      panel1: [0],
      panel2: [0]
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('writeOffSmallBalInit')])
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' }).catch(() => {})
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doSchedule()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSchedule() {
      const apiURI = this.menu.doSchedule
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, this.form)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.showErrorDialog = true
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doValTranDate() {
      if (this.form.tranDatePatchRec !== null || this.form.tranDatePatchRec !== '') {
        const apiURI = this.menu.validateTranDate
        if (apiURI) {
          this.dateLoading = true
          try {
            const expand = {
              tranDate: this.form.tranDate
            }
            await this.$http.get(expandURI(apiURI, expand))
            this.resetMessage('form.tranDate')
            this.dateLoading = false
          } catch (err) {
            this.dateLoading = false
            const { data } = err.response
            if (data) {
              this.fieldMessage(data)
            }
          }
        }
      }
    },
    doAssign(fieldName, obj) {
      switch (fieldName) {
        case 'branch':
          this.form.branch = obj.finalSelectedItems.toString()
          this.showBranchHelpList = false
          break
        case 'currency':
          this.form.curr = obj.finalSelectedItems.toString()
          this.showCurrencyHelpList = false
          break
        case 'inter':
          if (this.acctNoType === 'acctNoFrom') {
            this.form.acctNoFrom = obj
          } else if (this.acctNoType === 'acctNoTo') {
            this.form.acctNoTo = obj
          } else {
            this.form.acctNo = obj
            this.doValAcctNo()
          }
          break
        case 'interType':
          this.form.interType = obj.finalSelectedItems.toString()
          this.showInterTypeHelpList = false
          break
      }
    },
    doHelpList(fieldName) {
      switch (fieldName) {
        case 'acctNoFrom':
        case 'acctNoTo':
          this.showInterHelpList = true
          this.acctNoType = fieldName
          break
      }
    },
    acctNoFromValidate() {
      if ((this.form.acctNoFrom === null && this.form.acctNoTo !== null) || (this.form.acctNoFrom === '' && this.form.acctNoTo !== '')) {
        return 'required'
      } else {
        return 'acctNoRangeFrom:' + this.form.acctNoTo
      }
    },
    acctNoToValidate() {
      if ((this.form.acctNoFrom !== null && this.form.acctNoTo === null) || (this.form.acctNoFrom !== '' && this.form.acctNoTo === '')) {
        return 'required'
      } else {
        return 'acctNoRangeTo:' + this.form.acctNoFrom
      }
    },
    async doAssignClientType(Obj) {
      this.form.clientType = []
      this.form.clientType = Obj.finalSelectedItems.toString()
    },
    async doAssignIntermediaryType(Obj) {
      this.form.interType = []
      this.form.interType = Obj.finalSelectedItems.toString()
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valToday', {
      getMessage(field, args) {
        return 'Cannot be greater / later than system date(TODAY)'
      },
      validate(value, args) {
        if (value) {
          return !isAfter(removeTime(value), removeTime(new Date()))
        }
        return true
      }
    })
    this.$validator.extend('valTranDate', {
      getMessage(field, args) {
        return 'Cannot be greater / later than Set Write-off Transaction Date'
      },
      validate(value, args) {
        let tranDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(tranDate))
        }
        return true
      }
    })
    this.$validator.extend('acctNoRangeFrom', {
      getMessage: (field, args) => {
        return field + ' must less than or equal To Account No.'
      },
      validate: (value, args) => {
        if (value > args) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('acctNoRangeTo', {
      getMessage: (field, args) => {
        return field + ' must greater than or equal From Account No.'
      },
      validate: (value, args) => {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.writeOffSmalBal.menu
    },
    doValidateCutOffDate() {
      if (this.form.cutOffDate !== '' && this.form.cutOffDate !== undefined && this.form.cutOffDate !== null) {
        return 'required|valTranDate:' + this.form.tranDate + '|valToday'
      } else {
        return 'required'
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  mixins: [MessageMixin, commonAjaxMixin, commonMixins, accountsAjaxCalls],
  components: {
    MultiBranchHelpList,
    MultiCurrencyHelpList,
    IntermediaryHelpList,
    MultiClientTypeHelpList,
    MultiIntermediaryTypeHelpList
  }
}
</script>
<style lang="scss"></style>
